import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Scale, Landmark } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import CompareBanks from "@/components/CompareBanks";
import { setSeo, resetSeo } from "@/lib/seo";
import { useTranslation } from "react-i18next";

export default function BankComparePage() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setSeo({
      title: t("bankCompare.seoTitle"),
      description: t("bankCompare.seoDesc"),
      url: window.location.href,
    });
    return () => resetSeo();
  }, [t, i18n.language]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <section className="relative grain overflow-hidden border-b border-border bg-secondary/40">
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-32 pb-14">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="max-w-2xl">
            <p className="flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-orange-700"><Scale className="h-3.5 w-3.5" /> {t("bankCompare.kicker")}</p>
            <h1 className="mt-3 font-heading text-4xl sm:text-5xl tracking-tight text-foreground">{t("bankCompare.h1")}</h1>
            <p className="mt-4 text-muted-foreground">{t("bankCompare.lead")}</p>
            <Button variant="outline" className="mt-5 rounded-sm border-slate-300 bg-card hover:bg-secondary" onClick={() => navigate("/banks")} data-testid="bankcompare-browse-btn">
              <Landmark className="h-4 w-4 mr-1.5 text-orange-700" /> {t("bankCompare.browse")}
            </Button>
          </motion.div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <CompareBanks />
      </section>
      <Footer />
    </div>
  );
}
